import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useVisibleDateRangeEffect = (calendarView, selectedDate, callOrderOrCalendar, setComponentVisibleDateRange) => {
    useEffectWithErrorLogging(() => {
        setComponentVisibleDateRange();
    }, [calendarView, selectedDate, callOrderOrCalendar]);
};

export default useVisibleDateRangeEffect;
